import React from 'react'
import { StyledLi, StyledALink, StyledUl } from './styled'

export const FooterNavigation = () => {
  return (
    <StyledUl className="footer">
      <StyledLi>
        <StyledALink
          mode="dark"
          fontWeight={400}
          href={`${process.env.REACT_APP_DOMAIN}/contact`}
        >
          יצירת קשר
        </StyledALink>
      </StyledLi>
      <StyledLi>
        <StyledALink
          mode="dark"
          fontWeight={400}
          href={`${process.env.REACT_APP_DOMAIN}/accessibility`}
        >
          הצהרת נגישות
        </StyledALink>
      </StyledLi>
      <StyledLi>
        <StyledALink
          mode="dark"
          fontWeight={400}
          href={`${process.env.REACT_APP_DOMAIN}/terms`}
        >
          תנאי שימוש ומדיניות פרטיות
        </StyledALink>
      </StyledLi>
    </StyledUl>
  )
}
